import { UIElement } from "../common_ui_elements/ui_element.js";
import { Vector2 } from "../../common/vector2.js";

export abstract class AbstractTooltip extends UIElement
{
  constructor( ctx: CanvasRenderingContext2D, x: number, y: number, width: number, height: number )
  {
    super( ctx, x, y, width, height );
  }

  update( now:number ): void
  {
    this.updateBasic( now );
  }

  abstract render(): void;
  abstract name(): string;

  containsPointGlobal( p: Vector2 ): boolean
  {
    const pixel_pos = this.pixelPosForRender();

    // UIElement keeps its position in the transform. The rect itself is local
    // (normally starts at 0, 0), so using only rect.x/y moved the tooltip hit
    // area to the top-left corner of the canvas.
    const x = pixel_pos.x + this.rect.getX();
    const y = pixel_pos.y + this.rect.getY();
    const w = this.rect.getW();
    const h = this.rect.getH();

    return p.x > x
        && p.y > y
        && p.x < x + w
        && p.y < y + h;
  }
}
